/**
 * Phần dùng chung của bốn repository module `ocr` (loại chứng từ, model AI, chứng từ, kho bản OCR).
 *
 * Module chạy sau Gateway ở tiền tố `/api/v1/m/ocr` (manifest `routes[]`). Giao diện gọi qua Gateway
 * như mọi API khác; tenant lấy từ token, không gửi tham số.
 */
import type { ApiError } from '../errors';
import { mockRequest, mockState } from '../../mock/transport';

export const GOC_OCR = '/api/v1/m/ocr';

/** Máy chủ giả chạy **sau** nhịp chờ và các trạng thái `?mock=`: lỗi tới cùng độ trễ với lỗi thật. */
export const giaLap = <T>(lam: () => T): Promise<T> => mockRequest(undefined).then(lam);

/** Trang danh sách phải có mảng `items`; thiếu là route chưa trỏ đúng module. */
export function kiemTrang<T extends { items: unknown[] }>(trang: T): T {
  if (!Array.isArray(trang?.items)) {
    throw { code: 'INTERNAL', status: 200, message: '' } satisfies ApiError;
  }
  return trang;
}

export const maHoa = encodeURIComponent;

/**
 * Danh sách giả: `?mock=empty` và `?mock=filtered-empty` trả trang rỗng. Rỗng vì lọc được diễn ở
 * đây, không ở view: view phân biệt hai loại rỗng bằng chính bộ lọc của nó, như khi chạy thật.
 */
export function giaLapDanhSach<T>(lam: () => T, rong: T): Promise<T> {
  if (mockState() === 'filtered-empty') return mockRequest(rong);
  return mockRequest(undefined).then(() => (mockState() === 'empty' ? rong : lam()));
}
